export default __webpack_public_path__ + "static/media/ca-4-rMIN.d800e630.avif";